(function($){
    const $productSwatch = $('#product-swatch');
    const $quantity = $('.product-quantity-wrapper > .quantity');
    const $featuredProduct = $('.jq-featured-slider');
    const $addToCartMoney = $('.btn-add-tocart > .btn-money');
    const $addToCartItems = $('.btn-add-tocart > .btn-items');
    const $productVariants = $('.jq-swatch-element,.jq-product-variant');
    const $currentPrice = $('.product-price .current-price');
    const $currentComparePrice = $('.product-price .compare-price, .new-price-discounts-wrapper .compare-price');
    const $newCurrentPrice = $('.new-product-price .jq-new-price');
    const $newCurrentComparePrice = $('.new-product-price .jq-new-compare-price');
    const $allVariants = $('.all-variant');
    
    let _price = $(':selected', $allVariants).attr('data-price');

    function prepareVariants($variants) {
        return $variants.get().map(function(el){
            return el.value;
        });
    }
    
    function getVariation(all_variants, options) {
        const attrOptions = options.join(',').replace(/"/g, '\\"').replace(/'/g, "\\'");
        const variations = $(all_variants).find('option[data-options="' + attrOptions + '"]');
        
        if (variations.length > 0) {
            $(all_variants).val(variations.val()).trigger('change');
        }
    }
    
    function filterVariants(opt) {
        const settings = Object.assign({
            product: null,
            options: [],
            currentOption: null,
            swatchIndex: -1,
            enableATC: false
        }, opt);
        
        const swatchType = $('.swatch-type[data-index="' + (settings.swatchIndex + 1) + '"]');
        
        if (typeof settings.product.variations[settings.currentOption] !== 'undefined'){
            changeSwatchVariants({
                $swatch: swatchType,
                variants: Object.keys(settings.product.variations[settings.currentOption]),
                enableATC: settings.enableATC
            });
        }else if (typeof settings.product.variations[settings.options[0]] !== 'undefined' && typeof settings.product.variations[settings.options[0]][settings.currentOption] !== 'undefined'){
            changeSwatchVariants({
                $swatch: swatchType,
                variants: settings.product.variations[settings.options[0]][settings.currentOption],
                enableATC: settings.enableATC
            });
        }
    }
    
    function changeSwatchVariants(opt) {
        const settings = Object.assign({
            $swatch: {},
            variants: [],
            enableATC: false
        }, opt);

        const $swatchHTMLSelect = settings.$swatch.find('.product-variant option');
        const $swatchHTMLRadio  = settings.$swatch.find('.swatch-variant-value');

        $('.product-variant', settings.$swatch).prop('disabled', false);
        
        // BEGIN_TAG_SELECT
        $swatchHTMLSelect
            .prop({
                disabled: true,
                checked: false
            })
            .each(function(){
                if (settings.variants.indexOf($(this).val()) > -1) {
                    $(this).prop('disabled', false);
                }
            });
        
        const firstSelectedValue = $swatchHTMLSelect.filter(':not(:disabled):first').val();
        
        if (settings.enableATC) {
            $swatchHTMLSelect.parent().val(firstSelectedValue).trigger('change');
        }
        // END_TAG_SELECT

        // BEGIN_RADIO_BUTTON
        $swatchHTMLRadio
            .parent()
            .addClass('swatch-disabled');

        $swatchHTMLRadio
            .prop({
                disabled: true,
                checked: false
            })
            .each(function(i){
                if (settings.variants.indexOf($(this).val()) > -1) {
                    $(this).prop('disabled', false);
                    $(this).parent().removeClass('swatch-disabled');
                }
            });
        
        if (settings.enableATC) {
            $swatchHTMLRadio.filter(':not(:disabled):first').trigger('click');
        }
        // END_RADIO_BUTTON
        // settings.$swatch.prev().find('.choose-option').removeClass('choose-option');
    }

    // function chooseBeforeOption( i ) {
    //     $('.swatch-type[data-index="' + i + '"] .swatch-element').on('click', function(){
    //         const checkedSwatchTotal = $('.swatch-type[data-index="'+ (i - 1) +'"] input:checked').length;
    //         const isSelectedSwatch = typeof $('.swatch-type[data-index="'+ (i - 1) +'"] select').val() !== 'undefined' && $('.swatch-type[data-index="'+ (i - 1) +'"] select').val() !== '';
            
    //         $('.swatch-type.swatch-elements-wrapper').removeClass('choose-option');
            
    //         if (checkedSwatchTotal === 0 && isSelectedSwatch === false) {
    //             $('.swatch-type[data-index="'+ (i - 1) +'"] .swatch-elements-wrapper').addClass('choose-option');
    //         }
    //     });
    // }
    
    function youSave(compareAtPrice, price){
        const value = 100 - ((price * 100)/compareAtPrice);
        const $comparePercent = $('.compare_percent');
        const $youSaveMoney = $('.you-save-price .money');
        const $youtSave = $('.you-save-price');

        if(compareAtPrice <= price){
            return $youtSave.fadeOut(function(){
                $youtSave.hide();
            });
        }
        
        $comparePercent.html(" (" + value.toFixed(2) + "%)");
        $youSaveMoney.html(VastaShop.formatMoney(compareAtPrice - price));
        
        $youtSave.fadeIn(function(){
            $youtSave.show();
        });
    }

    // Product Options
    $productVariants.change(function(){
        var options = prepareVariants($('.jq-product-variant option:selected,.swatch-variant-value:checked', $productSwatch));

        getVariation($allVariants, options);

        // $(this).parent().removeClass('choose-option');

        filterVariants({
            product: VastaShop.Product.current,
            options: options,
            currentOption: $(this).val(),
            swatchIndex: parseInt($(this).attr('data-swatch-index')),
            enableATC: (options.length == VastaShop.Product.current.options.length)
        });

        if (options.length === VastaShop.Product.current.options.length) {
            $('.btn-add-tocart').prop('disabled', false);
            $('.product-form-buttons-wrapper,.btn-add-tocart').removeClass('hide');
            $('.btn-choose-variant').addClass('hide');
            enableInputs($('.all-variant option:selected').val());
            if(parseInt(VastaShop.Variables._input_qtd.val()) == 1){
                VastaShop.Variables._bt_minus.attr('disabled','disabled');
            }
        }
        return false;
    });
    var temp = '$';
    // Choosed Variant

    $allVariants.change(function() {
        try {
            $('#add-to-cart-error').addClass('hide');
            var variant_id = $(':selected', this).val();
            var variant_pack = $(':selected', this).attr('data-options').split(',')[0];
            var variant_size = $(':selected', this).attr('data-options').split(',')[1]||$(':selected', this).attr('data-options').split(',')[0];
            var variant_image_position = $(':selected', this).attr('data-image-position');
            var variant_price = $(':selected', this).attr('data-price');
            var variant_sku = $(':selected', this).attr('data-sku');
            var variant_inventory = parseInt($(':selected', this).attr('data-inventory'));
            var variant_available = $(':selected', this).attr('data-available');
            var variant_compare_at_price = $(':selected', this).attr('data-compare-at-price') === "" ? "" : VastaShop.formatMoney(parseInt($(':selected', this).attr('data-compare-at-price')), money_format) ;
            var compare_at_price = $(':selected', this).attr('data-compare-at-price') === "" ? "" : parseInt($(':selected', this).attr('data-compare-at-price')) ;
            const $priceunit = $('.price-per-unit-edits');

            $priceunit.hide();
            $priceunit.filter('[data-variant = "' + variant_id + '"]').show();

            $quantity.val( 1 );

            if (variant_image_position) {
                variant_image_position = Math.max(parseInt(variant_image_position) - 1, 0);

                if(slideCounter > 0){
                    $featuredProduct.slick('slickGoTo', variant_image_position || 0);
                }else{
                    setTimeout(function(){
                        $featuredProduct.slick('slickGoTo', variant_image_position || 0);
                        slideCounter++;
                    },600);
                }
            }

            variant_price = parseInt(variant_price);
            compare_at_price = parseInt(compare_at_price !== '' ? compare_at_price: 0);

            // Old Layout
            if ($currentPrice.length > 0) {
                $currentPrice.html(VastaShop.formatMoney(variant_price));
            }

            if ($currentComparePrice.length > 0) {
                $currentComparePrice.html(VastaShop.formatMoney(compare_at_price));
            }

            // New Layout
            if ($newCurrentPrice.length > 0) {
                $newCurrentPrice.html(VastaShop.formatMoney(variant_price).replace(/[^0-9,.]/gi, ''));
            }

            if ($newCurrentComparePrice.length > 0) {
                $newCurrentComparePrice.html(VastaShop.formatMoney(compare_at_price));
            }

            if (variant_price < compare_at_price) {
                $currentComparePrice.show();
            } else {
                $currentComparePrice.empty().hide();
            }
            _price = $(':selected', $allVariants).attr('data-price');
            $addToCartMoney.html(VastaShop.formatMoney(parseInt($quantity.val()) * _price));
            $quantity.attr('data-max', variant_inventory);
            inventoryControl(variant_id);
            enableInputs(variant_id);
            if (parseInt($quantity.val()) == 1 ){
                $quantity.siblings('.btn-minus').attr('disabled','disabled');
            }
            quantity = parseInt($('#ProductQuantity').val());
            price    = parseInt($('.product-variant[name="id"] option:selected').data('price'));
            youSave(compare_at_price,parseInt(variant_price));
            if(quantity > 1) {
                $($addToCartItems).html(quantity + " ITEMS")
            } else {
                $($addToCartItems).html(quantity + " ITEM")
            }
            if ('true' === variant_available) {
                $('.product-quantity,#AddToCart2').show();
                $('.product-quantity,#AddToCart').show();
                $('#button-out-of-stock').hide();
                $('#button-out-of-stock-2').hide();
                $('#tabs-button-out-of-stock').hide();
            } else {
                $('.product-quantity,#AddToCart2').hide();
                $('.product-quantity,#AddToCart').hide();
                $('#button-out-of-stock').show();
                $('#button-out-of-stock-2').show();
                $('#tabs-button-out-of-stock').show();
                
            }

            Shopify.replaceState(Shopify.newState('size', encodeURI(variant_size)));
            Shopify.replaceState(Shopify.newState('pack', encodeURI(variant_pack)));
            $('.variant-sku').html('SKU# ' + variant_sku)

            if (('false' === variant_available) &&(typeof(BIS) == 'object') ){
                console.log("CUSTOM-SWATCH.JS VARIANT UNAVAILABLE SELECTED");
                BIS.popup.toggle();
                BIS.popup.form.selectVariant(variant_id);
            }
          
          document.querySelectorAll(".linkable-swatch-param").forEach(function(el){ 
            el.href=el.href.replace(/\?(.*)/gi,"")+location.search
          })
          
        } catch(e){
            console.error(e);
        }
    });


        $('.swatch-type[data-index="1"] .swatch-element').each(function(){
            if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('data-swatch')) > -1) {
                $(this).removeClass('swatch-disabled').find('input').prop('disabled', false);
            } else {
                $(this).find(".tooltip").remove();
            }
        });

        $('.swatch-type[data-index="1"] .jq-product-variant option').each(function(){
            if (Object.keys(VastaShop.Product.current.variations).indexOf($(this).attr('value')) < 0 && $(this).attr('value') !== '') {
                $(this).prop('disabled', true);
            }
        });

       if (VastaShop.Product.options.length > 0) {
            const sizeURLParam = Shopify.urlParam('size');
            const typeURLParam = Shopify.urlParam('pack');
             
         if (typeURLParam) {
                  const type = typeURLParam.replace(/(.*)=/gi, '')
                  $('.swatch-element[data-swatch="' + type + '"]').trigger('click');
               var indexswatchPack = $('.swatch-element[data-swatch="' + type + '"]').closest("[data-slick-index]").attr("data-slick-index")||0
                
              }
         
            if (sizeURLParam) {
                const size = sizeURLParam.replace(/(.*)=/gi, '')
                $('.swatch-element[data-swatch="' + size + '"]').trigger('click');
             var indexswatch = $('.swatch-element[data-swatch="' + size + '"]').closest("[data-slick-index]").attr("data-slick-index")||0
              
          }   
      
         
  }
        if (prepareVariants($('.swatch-variant-value:checked', $('.swatch-element'))).length == VastaShop.Product.current.options.length) {
            $currentPrice.html(VastaShop.formatMoney($(':selected', $allVariants).attr('data-price')));
            $addToCartMoney.html(VastaShop.formatMoney(parseInt($quantity.val()) * _price));
        }

        $('.modal-close').click(function(){
            $('.modal-container').removeClass('active');
        });

        $(window).click(function(e){
            if (e.target == $('.modal-container').get(0))
            $('.modal-container').removeClass('active');
        });

        // for (var i = 2, j = VastaShop.Product.current.options.length+1; i < j; i++) {
        //     chooseBeforeOption( i );
        // }

})(jQuery);